
    var riot = require('riot')
    //src: starling/src/tags/region-creation-tool.html
riot.tag2('region-creation-tool',
  '<span ref="overlay" class="region-creation-tool_overlay" hidden onmousedown="{handleMouseDown}" onmousemove="{handleMouseMove}" onmouseup="{handleMouseUp}"></span>',
  'region-creation-tool .region-creation-tool_overlay,[data-is="region-creation-tool"] .region-creation-tool_overlay{ position: fixed; top: 0; bottom: 0; right: 0; left: 0; background: blue; opacity: 0; z-index: 0; }',
  '', function(opts) {
'use strict';

var _this = this;

var _regionUi = require('lib/region-ui');

var _creationToolsUi = require('lib/creation-tools-ui');

var _constants = require('lib/constants');

var minWidth = 225;
var minHeight = 75;

canvas.regionCreationToolTag = this;

this.handleMouseDown = function (e) {
  var _canvas$getMatrix = canvas.getMatrix(),
      scale = _canvas$getMatrix.scale,
      tx = _canvas$getMatrix.tx,
      ty = _canvas$getMatrix.ty;

  _this.dragging = true;
  _this.nascentRegion = _regionUi.regionUI.createRegion({
    title: '',
    top: (e.clientY - ty) / scale,
    left: (e.clientX - tx) / scale
  });
  _regionUi.regionUI.onResizeStart(e, {
    moving: { bottom: true, right: true },
    regionId: _this.nascentRegion.id
  });
};

this.handleMouseMove = function (e) {
  if (!_this.dragging) return;
  _this.mouseMove = true;

  var _canvas$getMatrix2 = canvas.getMatrix(),
      scale = _canvas$getMatrix2.scale,
      tx = _canvas$getMatrix2.tx,
      ty = _canvas$getMatrix2.ty;

  var nascentRegion = _this.nascentRegion;
  if (nascentRegion) {
    _regionUi.regionUI.applyResize({
      region: nascentRegion,
      rect: {
        left: nascentRegion.x,
        top: nascentRegion.y,
        right: (e.clientX - tx) / scale,
        bottom: (e.clientY - ty) / scale
      }
    });
  }
  canvas.regionTags[_this.nascentRegion.id].update();
};

this.handleMouseUp = function (e) {
  if (_this.dragging) {
    _this.dragging = false;
    var region = _this.nascentRegion;
    if (!_this.mouseMove) {
      region.right = region.left + _constants.REGION_DEFAULT_SIZE.X;
      region.bottom = region.top + _constants.REGION_DEFAULT_SIZE.Y;
    }
    if (region.right - region.left < minWidth) {
      region.right = region.left + minWidth;
    }
    if (region.bottom - region.top < minHeight) {
      region.bottom = region.top + minHeight;
    }
    _regionUi.regionUI.setTitle({ regionId: region.id, title: 'Untitled Region' });
    _this.mouseMove = null;
    var regionTag = canvas.regionTags[region.id];
    regionTag.deSelect();
    regionTag.update();
    regionTag.onResizeMoveEnd(e);
    _regionUi.regionUI.selectRegion(region.id);
    _creationToolsUi.ctui.setActiveTool('pointer');
  }
  _this.hide();
};
this.hide = function () {
  _this.refs.overlay.hidden = true;
};
this.show = function () {
  _this.refs.overlay.hidden = false;
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('region-creation-tool')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/region-creation-tool.html
// module id = 777
// module chunks = 0